<template>
  <div class="forgotPassword">
    <div class="container">
      <h1>パスワードを忘れた</h1>
      <el-row class="container__form">
        <el-input placeholder="example@gmail.com" v-model="email"></el-input>
      </el-row>
      <el-row class="container__buttons">
        <div class="button button--right">
          <el-button @click="onClickBack">戻る</el-button>
          <el-button @click="onClickResetPassword" type="primary"
            >パスワードをリセット</el-button
          >
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import Auth from "@/services/auth.service";
const authService = new Auth();

export default {
  components: {},
  mounted () {},
  data () {
    return {
      email: "",
    };
  },
  methods: {
    onClickBack () {
      const { $router } = this;
      $router.push("/sign-in");
    },
    async onClickResetPassword () {
      const { $router, email } = this;
      const { commit } = this.$store;
      await resetPassword(email);
      alert("パスワードリセットのメールを送信しました");
      commit("auth/set", email);
      $router.push({ path: "/verify", params: { email } });
    },
  },
};

/**
 * send password reset email
 * @async
 * @param {string} email - The email address
 * @returns {Promise<Object>} Promise object represents the result of authentication
 */
async function resetPassword (email) {
  try {
    return await authService.forgotPassword(email);
  } catch (err) {
    return false;
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.container {
  position: absolute;
  width: 40vw;
  height: 40vw;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.logo {
  width: 80%;
  margin: 50px auto;
}
.container__form {
  margin-bottom: 10px;
}
.container__buttons {
  display: flex;
}

.button {
  display: flex;
  flex: 1;
  align-items: flex-end;
}

.button--right {
  justify-content: flex-end;
}
</style>
